import { Shuffle } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useShufflePlaylist } from '~/api/playlists/shuffle';
import { Tooltip } from '~/components/Tooltip';

export interface ShuffleButtonProps {
  enabled: boolean;
  playlistId: number;
}

export const ShuffleButton = ({ enabled, playlistId }: ShuffleButtonProps) => {
  const { t } = useTranslation();
  const [shufflePlaylist, { loading }] = useShufflePlaylist();

  const handleClick = useCallback(async () => {
    await shufflePlaylist({
      variables: {
        input: {
          playlistId,
        },
      },
    });
  }, [playlistId, shufflePlaylist]);

  return (
    <Tooltip
      title={
        enabled
          ? t('components.playlist_detail_page.shuffle_tooltip_enabled')
          : t('components.playlist_detail_page.shuffle_tooltip_disabled')
      }
    >
      <span>
        <LoadingButton
          color="primary"
          disabled={!enabled}
          loading={loading}
          loadingPosition="start"
          onClick={handleClick}
          startIcon={<Shuffle />}
          type="submit"
          variant="outlined"
        >
          {t('components.playlist_detail_page.shuffle_button')}
        </LoadingButton>
      </span>
    </Tooltip>
  );
};
